import {
  calendarIcon,
  coinsIcon,
  mobileIcon,
  moneyBillsIcon,
  phoneCallIcon,
} from '@/assets/images/offer/partner';
import type { OfferFaqItem } from '../../components/OfferFaq';
import type { OceanOfferType } from '../../components/OceanOfferFace';

interface PartnerOfferContent {
  titleAccent: string;
  title: string;
  description: [string, string];
  usps: { icon: string; text: string[] }[];
  faq: OfferFaqItem[];
}

const APPROVAL_ANSWER = [
  'Oferta preliminară o vezi imediat, pe baza istoricului tău de la Biroul de Credit. Oferta finală o primești după verificarea identității și confirmarea veniturilor de la ANAF.',
];

const AMOUNT_ANSWER = [
  'Suma se stabilește pe baza istoricului tău de la Biroul de Credit și a veniturilor confirmate de ANAF.',
];

const DOCUMENTS_ANSWER = [
  'Ai nevoie doar de actul de identitate. Veniturile le verificăm direct la ANAF, cu acordul tău; doar în unele cazuri îți putem cere o dovadă de venit.',
];

export const PARTNER_OFFER_CONTENT: Record<OceanOfferType, PartnerOfferContent> = {
  'credit-line': {
    titleAccent: 'Linia ta de credit',
    title: 'Rezerva ta de bani',
    description: ['Retragi și rambursezi oricând.', 'Dobândă doar pe suma utilizată.'],
    usps: [
      { icon: moneyBillsIcon, text: ['Plătești doar', 'cât folosești'] },
      { icon: coinsIcon, text: ['Costuri transparente'] },
      { icon: phoneCallIcon, text: ['Flexibilitate totală'] },
      { icon: mobileIcon, text: ['Gestionare în aplicație'] },
    ],
    faq: [
      {
        question: 'Ce este o linie de credit si cum functioneaza?',
        answer: [
          'Linia de credit este un imprumut flexibil care iti permite sa accesezi bani exact cand ai nevoie. Primesti o limita aprobata din care retragi partial. Dobanda se aplica doar la suma utilizata. Beneficiaza de un credit flexibil si rapid, cu o dobanda avantajoasa si conditii simple de aprobare.',
          'O linie de credit online este o soluție de finanțare care îți oferă acces la bani în mod flexibil, fără a fi nevoie să soliciți un nou împrumut de fiecare dată. Spre deosebire de un credit clasic, unde primești suma integral și o rambursezi în rate fixe, linia de credit îți permite să retragi doar cât ai nevoie și să rambursezi în ritmul tău.',
        ],
      },
      {
        question: 'Cât durează aprobarea unei linii de credit?',
        answer: APPROVAL_ANSWER,
      },
      {
        question: 'Când pot folosi banii?',
        answer: [
          'După semnarea contractului poți retrage bani din limita aprobată oricând ai nevoie.',
        ],
      },
      { question: 'Cum se stabilește suma aprobată?', answer: AMOUNT_ANSWER },
      { question: 'Ce documente sunt necesare?', answer: DOCUMENTS_ANSWER },
      {
        question: 'Pot rambursa anticipat?',
        answer: [
          'Da, poți rambursa oricând, integral sau parțial. Dobânda se aplică doar pe suma utilizată.',
        ],
      },
    ],
  },
  installment: {
    titleAccent: 'Credit în rate',
    title: 'Pentru nevoile tale',
    description: ['Rambursare în rate lunare egale.', 'Durată prestabilită.'],
    usps: [
      { icon: moneyBillsIcon, text: ['Rate lunare', 'fixe'] },
      { icon: coinsIcon, text: ['Costuri transparente'] },
      { icon: calendarIcon, text: ['Tu alegi', 'perioada'] },
      { icon: mobileIcon, text: ['Gestionare în aplicație'] },
    ],
    faq: [
      {
        question: 'Ce este un credit în rate si cum functioneaza?',
        answer: [
          'Creditul în rate îți oferă întreaga sumă de la început, pe care o rambursezi în rate lunare egale, pe durata aleasă de tine la semnarea contractului.',
        ],
      },
      {
        question: 'Cât durează aprobarea unui credit în rate?',
        answer: APPROVAL_ANSWER,
      },
      { question: 'Cum se stabilește suma aprobată?', answer: AMOUNT_ANSWER },
      { question: 'Ce documente sunt necesare?', answer: DOCUMENTS_ANSWER },
      {
        question: 'Pot rambursa anticipat?',
        answer: [
          'Da, poți rambursa anticipat, integral sau parțial, oricând pe durata creditului.',
        ],
      },
    ],
  },
};
